import React, { Component, useState, useEffect } from "react";
import '../../../src/index.css'
import { BrowserRouter, Link, NavLink, useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';
import { TextField } from '@mui/material';
import { Container } from '@mui/material';
import { Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import useMediaQuery from '@mui/material/useMediaQuery';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { HashLink } from 'react-router-hash-link';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

function KamoHeader() {

  return (

    <Box>

      <AppBar position="static" className='app-tool'>
        <Toolbar className="headtool">
          <Link to="/"><img src={process.env.PUBLIC_URL + '/images/products/new/kamologo.png'} alt="Slide" style={{ width: '145px' }} />
          </Link>


        </Toolbar>
      </AppBar>


    </Box>
  );
}

export default KamoHeader;
